import { memo } from 'react';
import { IOrder } from 'modules/sales/common/interfaces/IOrder';
import { FlexBox } from '@dfl/mui-react-common';
import SuborderExportMenu from 'modules/sales/common/components/SuborderExportMenu/SuborderExportMenu';
import { SuborderCompleteButton } from 'modules/sales/common/components/SuborderCompleteButton';

type UserStatusProps = {
  record: IOrder;
};

const SuborderRowActions = ({ record }: UserStatusProps) => {
  return (
    <FlexBox alignItems={'center'} gap={1}>
      <SuborderCompleteButton order={record} variant='icon' />
      <SuborderExportMenu order={record} variant='icon' />
    </FlexBox>
  );
};

export default memo(SuborderRowActions);
